/* Syncs the "Size · VALUE" text above the variant pills when the shopper
   picks a different variant. Dawn re-renders the pill fieldsets on change,
   but this label row lives outside that re-render scope, so it must be
   updated manually from the variantChange pub/sub event. */
(function () {
  if (typeof subscribe === 'undefined' || typeof PUB_SUB_EVENTS === 'undefined') return;

  subscribe(PUB_SUB_EVENTS.variantChange, (event) => {
    const { sectionId, variant } = event.data || {};
    if (!variant || !variant.options) return;

    const section = document.getElementById(`MainProduct-${sectionId}`);
    if (!section) return;

    // Label rows render in the same order as variant.options (option1..3)
    section.querySelectorAll('.ht-pdp__variant-selected-value').forEach((span, i) => {
      if (variant.options[i]) span.textContent = ` · ${variant.options[i]}`;
    });
  });
})();
